var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-sheet-field',{attrs:{"is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[_vm._v(" "+_vm._s(_vm.players)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }